import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { IoClose } from "react-icons/io5";
// import {AiOutlineInfoCircle} from "react-icons/ai";
import Button from "@mui/material/Button";
import React from "react";
import '../../SelfServe/InfluencerStepper.css';
import OneOffPaymentImage from '../../../media/site_media/dashboard/oneoffpayments.jpg'
// import ModalImageSmall from "../../media/site_media/background_images/demo-small.webp";
// import Confetti from "react-confetti";
import { gtag } from "ga-gtag";



export default function PayoutModal(props) {



    // Opened with props passed from -> http://localhost:3000/become-a-creator/register
    return (

        <Modal
            open={props.payoutModal}
            onClose={() => props.handlePayoutModalClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableAutoFocus={true}
            sx={{ display: 'flex', overflow: 'auto', height: 'auto', outline: 'none', border: 'none', backgroundColor: 'rgba(0,0,0,0.6)' }}

        // sx={{
        //    margin: 'auto',
        //    backgroundColor: 'rgba(0,0,0,0.47)',
        //    outline: '0',
        //    // position: 'relative',
        //    // borderRadius: '5px',
        //    overflow: 'auto',
        //    minWidth: '100vw',
        //    // minWidth: '50vw',
        //    display: 'flex',
        //    zIndex: '1300',
        //    lineHeight: '25px',
        //    width:'100%',
        //    minHeight: '100vh',
        //    // maxHeight: '100vh',
        // }}
        >
            <div style={{ width: '100%', height: '100%', overflow: 'auto', outline: 'none', border: 'none', display: 'flex' }}>



                <Grid container justifyContent='center' sx={{
                    paddingTop: '20px',
                    paddingBottom: '20px', width: '100%', borderRadius: '5px', margin: 'auto',
                    maxWidth: '650px', outline: 'none'
                }}>


                    <Grid
                        style={{
                            zIndex: '100',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            padding: '30px 30px',
                            boxSizing: 'border-box',
                            width: '100%',
                            outline: '0px',
                            maxWidth: '550px',
                            minWidth: '320px',
                            backgroundColor: 'white',
                            borderRadius: '10px',
                            height: 'auto',
                            // minHeight: 'auto',
                            position: 'relative',
                            margin: props.windowWidth < 400 ? '0' : '0 auto',
                        }}
                    >




                        <Grid container
                            style={{
                                width: window.innerWidth > 1200 ? "100%" : '100%',
                                justifyContent: "center",
                                alignItems: "center",
                                height: 'auto',
                                margin: '0px auto 10px auto',
                                maxHeight: "2000px",
                                display: "flex",
                            }}>
                            <Grid lg={11} xs={11}>
                                <h3 style={{ margin: '10px 0px' }}>Instant Payout</h3>
                            </Grid>
                            <Grid lg={1} xs={1}
                                style={{
                                    top: '0px',
                                    padding: '0px',
                                    float: 'right',
                                    textAlign: 'right',
                                }}
                            >
                                <div style={{ '&:hover': { cursor: 'pointer' } }}>
                                    <a onClick={() => {
                                        props.handlePayoutModalClose()


                                    }}>
                                        <IoClose className={'modal-close-icon'} style={{ width: '25px', height: '25px' }} />
                                    </a>
                                </div>

                            </Grid>



                        </Grid>



                        <div style={{
                            backgroundColor: '#D3DCE7',
                            marginTop: '0px',
                            width: '100%',
                            height: '1px',
                            marginBottom: '10px',
                            margin: '10px auto',
                            padding: '0px 0px'
                        }} />

                        <Grid container>
                            <Grid md={12} xs={12} sx={{ margin: '10px 0px 0px 0px' }}>
                                <div style={{ width: '100%', display: 'flex' }}>

                                    <span style={{
                                        color: '#222222',
                                        fontWeight: '700',
                                        fontSize: '14px',

                                    }}>Enter Payout Amount</span>

                          


                                </div>
                                <div>
                                    <style>
                                        {`
                    /* Chrome, Safari, Edge, Opera */
                    input::-webkit-outer-spin-button,
                    input::-webkit-inner-spin-button {
                      -webkit-appearance: none;
                      margin: 0;
                    }
          
                    /* Firefox */
                    input[type=number] {
                      -moz-appearance: textfield;
                    }
                  `}
                                    </style>
                                    <form style={{
                                        backgroundColor: '#ffffff',
                                        color: '#fff',
                                        borderRadius: '5px',
                                        padding: '0px 15px',
                                        display: 'flex',
                                        height: '46px',
                                        margin: '10px 0px 10px 0px',
                                        border: '1px solid #C7D1DE',
                                        width: '100%',
                                        maxWidth: '800px',
                                        zIndex: '10',
                                        boxSizing: 'border-box'
                                    }}>
                                        <span style={{ fontWeight: '500', margin: '11.5px 5px auto 0px', fontSize: '16px', color: "#000", }}>{props.start_symbol}</span>
                                        <input type={"number"} id={"emailCaptureInput"} style={{
                                            border: 'none', width: window.innerWidth > 560 ? '85%' : '72%', fontWeight: '500', color: '#1D1D1D', fontSize: '16px',
                                            fontFamily: 'Roboto'
                                        }}

                                            placeholder='Enter payout amount...'
                                            value={props.withdraw_amount}
                                            // value={this.props.monthlyPriceStr!=='0'?this.props.currencySymbol + this.props.monthlyPriceStr + this.props.currencySymbolPost:''}
                                            onChange={(event) => {
                                                props.handlePayoutAmountUpdate(event)
                                                
                                            }}
                                        />


                                    </form>

                                            <span style={{
                                                color: '#6E89AF',
                                                fontWeight: '600',
                                                fontSize: '14px',
                                                margin: '0px 0px 0px auto'

                                            }}>Available Balance: {props.availableBalance}</span>
                                    
                                </div>

                            </Grid>

                        </Grid>


                        <div style={{ margin: '10px 0px 0px 0px', display: 'flex' }}>


                            <Grid container justifyContent={'space-between'}>
                                <Grid xs={12} md={5.8} style={{ margin: '10px 0px 0px 0px', }}>
                                    <Button
                                        disableRipple
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            backgroundColor: '#ffffff',
                                            color: 'var(--brand-color)',
                                            fontSize: '14px',
                                            textTransform: 'none',
                                            margin: 'auto 0px auto 0px',
                                            boxShadow: 'none',
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            border: '2px solid var(--brand-color)',

                                            ':hover': {
                                                backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                                border: '2px solid var(--brand-color-hover)',
                                                color: 'white', boxShadow: 'none',
                                            },
                                        }}
                                        type="submit" value="LOGIN"
                                        // onClick={() => {
                                        //     this.processPayout();
                                        // }}

                                        onClick={props.handlePayoutModalClose}


                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid xs={12} md={5.8} style={{ margin: '10px 0px 0px 0px', }}>
                                    {/* <span style={{ margin: 'auto', fontWeight: '600', fontSize: '12px', margin: 'auto 10px auto 0px', }}>OR</span> */}

                                    <Button
                                        fullWidth
                                        disableRipple
                                        variant="contained"
                                        sx={{
                                            backgroundColor: 'var(--brand-color)',
                                            fontSize: '14px',
                                            textTransform: 'none',
                                            margin: 'auto 0px auto 0px',
                                            boxShadow: 'none',
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            border: '2px solid var(--brand-color)',

                                            ':hover': {
                                                border: '2px solid var(--brand-color-hover)',
                                                backgroundColor: 'var(--brand-color-hover)', // theme.palette.primary.main
                                                color: 'white', boxShadow: 'none',
                                            },
                                        }}
                                        type="submit" value="LOGIN"
                                        onClick={() => {
                                            props.processPayout();
                                        }}
                                    >
                                        Payout
                                    </Button>

                                </Grid>

                            </Grid>




                        </div>



                    </Grid>
                </Grid>

            </div>
        </Modal>
    )

}


